export enum ErrorTypes {
    userNotActivated = 'user not activated',
    emailMismatch = 'Login blocked because of email mismatch',
}
